import { FC } from 'react'
import { Box } from '@mui/material'
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'

import { DrawerLinkElement } from 'components/shared/DrawerLinkElement'
import { PartnerPageData } from 'types/types'

export interface ProfileDrawerLinksListProps {
  pageTheme: PartnerPageData
}

export const ProfileDrawerLinksList: FC<ProfileDrawerLinksListProps> = ({ pageTheme }) => {
  return (
    <Box display="flex" flexDirection="column" p={1} gap={0.5}>
      <DrawerLinkElement
        icon={<ConfirmationNumberOutlinedIcon />}
        text="My Tickets"
        link={`/${pageTheme.company_domain}/prize-draw/my-tickets`}
      />
      <DrawerLinkElement
        icon={<HelpOutlineOutlinedIcon />}
        text="Prize draw FAQ's"
        link={`/${pageTheme.company_domain}/prize-draw/faq`}
      />
      <DrawerLinkElement
        icon={<ShieldOutlinedIcon />}
        text="Player Protection"
        link={`/${pageTheme.company_domain}/prize-draw/player-protection`}
      />
      <DrawerLinkElement
        icon={<HistoryOutlinedIcon />}
        text="Previous Draw Results"
        link={`/${pageTheme.company_domain}/prize-draw/results`}
      />
    </Box>
  )
}
